import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {SxProps} from '@mui/material';

import {EmpionButton} from '../../../../../../../components/EmpionButton/EmpionButton';
import {SnackBarContext} from '../../../../../../../contexts/SnackBarContext/SnackBarContext';
import {orangeColors} from '../../../../../../../layouts/theme/designSystem';
import {AppConfig} from '../../../../../../../lib/AppConfig';
import {copyTextToClipBoard} from '../../../../../../../utils/copyTextToClipboard/copyTextToClipBoard';
import {Survey} from '../../../types/SurveyTypes';

interface ClipboardProps {
  text: string;
  styles?: SxProps;
  survey: Survey | undefined;
  showMode?: boolean;
}

export default function Clipboard({text, styles, survey}: ClipboardProps) {
  const {t} = useTranslation();
  const {dispatchMessage} = useContext(SnackBarContext);

  const getButtonBackgroundColor = () => {
    if ((styles as {backgroundColor?: string})?.backgroundColor) {
      return (styles as {backgroundColor?: string})?.backgroundColor;
    }
    return orangeColors[5];
  };

  const handleCoppyLink = async () => {
    if (!survey?.surveyCode || !survey?.defaultLanguage) return;
    const baseUrl = AppConfig.PLATFORM_BASE_URL;
    // eslint-disable-next-line max-len
    const surveyUrl = `${baseUrl}/company/culture-survey?code=${survey?.surveyCode}&initLang=${survey?.defaultLanguage}`;

    const res = await copyTextToClipBoard(surveyUrl);
    if (res) {
      dispatchMessage(t('companySurveys.actionButtons.copySurveyLinkSuccess'), 'success');
    } else {
      dispatchMessage(t('companySurveys.actionButtons.copySurveyLinkError'), 'error');
    }
  };

  return (
    <>
      <EmpionButton
        sx={{
          ...styles,
          backgroundColor: getButtonBackgroundColor(),
          borderRadius: '8px',
        }}
        id={`${survey?.resourceId}-button`}
        onClick={handleCoppyLink}
        startIcon={<ContentCopyIcon fontSize='small' />}
      >
        {text}
      </EmpionButton>
    </>
  );
}
